// extracted by mini-css-extract-plugin
export var statusCell = "_46947c308fc54940ef7a3f8a3e52b321-css";
export var statusCellLabel = "bbcbfb95a0ad271050034eca2c8d1a84-css";